import React, { useState, useRef, useEffect } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { switchRoleApi } from "../../../service/api/user/switchRole";
import { setUserDetails } from "../../../feature/userData/userData";
import ResponceToaster from "../responceToaster/responceToaster";
import { useNavigate } from 'react-router-dom';


const SwitchRole = ({ rolesArray, defaultRoleId, defaultUserRoleName, onClose, modalStatus, changeDefaultRole }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const state = useSelector((state) => state);
  const [responceMsg, setResponceMsg] = useState("");
  const [toasterType, setToasterType] = useState();
  const [handleToaster, setHandleToaster] = useState(false);
  const [switchLoading, setSwitchLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

  };


  function changeRole(e) {
    //     setChangeRoleModal(true)
    setSwitchLoading(true)
    localStorage.setItem("roleId", e)
    let data = {
      role_id_int: localStorage.getItem("roleId")
    }
    dispatch(switchRoleApi(data, (res) => {
      localStorage.setItem("access_token", res.data.access_token)
      localStorage.setItem("refresh_token", res.data.refresh_token)
      dispatch(setUserDetails(res.data.data))
      navigate("/dashboard")

      onClose();
      setSwitchLoading(false)


      setResponceMsg(res.data.message);
      // setToasterType("success");
      // setHandleToaster(true);

      // setTimeout(() => {
      //   setHandleToaster(false);
      // }, 11000);
    }, (err) => {
      setResponceMsg(err.data.message);
      setToasterType("success");
      setHandleToaster(true);
      setTimeout(() => {
        setHandleToaster(false);
      }, 11000);

      setSwitchLoading(false)
    }))

  }


  return (
    <>
      {/* <!-- Modal --> */}
      <Modal
        className="fade"
        show={modalStatus}
        // onHide={handleCloseChangePassword}
        centered
      >
        <Modal.Header style={{ borderBottom: "none" }}>
          <Modal.Title>{" Switch Role"}</Modal.Title>

          <Button
            variant=""
            className="btn-close btn-close-password"
            onClick={onClose}
          ></Button>
        </Modal.Header>
        <Modal.Header>Current role is  :- {defaultUserRoleName}</Modal.Header>
        <Modal.Body>
          <form onSubmit={(e) => handleSubmit(e)}>

            <div className="mb-3">
              <label className="mb-1">
                <strong>{"Change Role"} </strong>
              </label>
              <div
                style={{
                  display: 'flex',
                  justifyContent: "space-between",
                  pointerEvents: switchLoading ? "none" : "auto",
                  opacity: switchLoading ? "0.5" : "1"
                }}
              >
                {/* <select
                  placeholder="Select"
                  style={{
                    border: "2px solid rgba(107, 107, 107, 0.12)",
                    cursor: "pointer",
                  }}
                  className="custom-select join-as-style"
              
                //   onChange={changeRole}
                 
                 >
                    <option >{defaultUserRoleName}</option>
                   
                 { rolesArray.length > 1 &&   rolesArray.map(({role_id_ids,role_name_chr},index)=>(role_id_ids != defaultRoleId && <option key={index} value={role_id_ids}  >{role_name_chr}</option>))}
                
                </select> */}

                {rolesArray?.length > 1 && rolesArray?.map(({ role_id_ids, role_name_chr, role_display_name_chr }, index) => (<div style={{ marginTop: '10px' }} ><input
                  type="radio"

                  className="form-check-input"
                  id="customCheckBox1"
                  required=""
                  style={{ display: 'inline-block', margin: '0px' }}
                  checked={role_id_ids == defaultRoleId}
                  onChange={() => {
                    // changeDefaultRole(role_id_ids, role_display_name_chr)
                    changeRole(role_id_ids)
                  }}

                />
                  <span
                    className="form-check-label cursor-pointer text-hovered font-w600"
                    onClick={() => {
                      changeRole(role_id_ids)
                    }}
                  >
                    {role_display_name_chr}
                  </span>
                </div>))}
              </div>

              {switchLoading &&
                <div className="mt-3 d-flex justify-content-end">
                  <Spinner animation="border" size="sm" variant="primary" />
                </div>
              }
            </div>

          </form>
        </Modal.Body>
      </Modal>

      {handleToaster && <ResponceToaster toasterType={toasterType} message={responceMsg} />}

    </>
  );
};

export default SwitchRole;